<h2>Consigna</h2>
<p>
    El servicio meteorológico nacional (SMN) brinda mediante una API la información actualizada del clima para las ciudades más importantes de Argentina.
</p>
<p>
    El objetivo es listar los datos brindados por la API respetando las siguientes reglas:
</p>
<ul>
    <li>
        Listar en una tabla todas las ciudades que brindadas. Se valora si la tabla se
        encuentra paginada.
    </li>
    <li>
        Cada ciudad listada, deberá contar con un botón “Detalle” que al accionarlo proporcionará más datos del clima.
    </li>
    <li>
        No es necesario que se utilice toda la información que se recibe de la API, sino los datos más relevantes.
    </li>
</ul>
<p>
    No hay restricciones en cuanto a la tecnología utilizar, ya sea si se utiliza HTML puro o algún framework basado en componentes.
</p>
<p>
    Se valora el uso de estilos que mejoren la calidad visual y experiencia del usuario al utilizar la aplicación.
</p>
<p>
    Si para levantar la aplicación se requiere algún paso extra, agregar al proyecto un archivo ​README.md​, donde se deberán detallar los pasos a seguir.
</p>
<p>
    Todo el código deberá ser subido a un repositorio público GIT. Al finalizar, debe enviarse el enlace al email, para poder acceder al mismo.
</p>